import PublicAccessClient from "./clients/PurchaseOrderClient";

export default {
  getSearch(body) {
    return PublicAccessClient.get(`search?filter=${body}`);
  },
};
